import styled from 'styled-components';

export const ListingBreadcrumbsWrapper = styled.div`
  margin-bottom: 2rem;
`;

export const ListingSubtitle = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.palette.gray};
  margin-bottom: 0.5rem;
`;

export const ListingTitle = styled.h1`
  font-size: 2rem;
  margin: 0;
`;

export const ListingTitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;
